// extracted by mini-css-extract-plugin
export default {"wrapper":"BottomNavigationButtonsMobile_wrapper__2F++R","button":"BottomNavigationButtonsMobile_button__i+5xQ"};